<script>
export default {
  props: [ 'amount' ],

  // eslint-disable-next-line vue/component-api-style
  methods: {
    formatPrice(value) {
      return new Intl.NumberFormat().format(value)
    },
  },
}
</script>

<template>
  <span class="price-html">
    {{ formatPrice(amount) }}
    <span class="currency">تومان</span>
  </span>
</template>
